import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Publish from "@material-ui/icons/Publish";
import Cancel from "@material-ui/icons/Cancel";
import Delete from "@material-ui/icons/Delete";
import { withStyles } from "@material-ui/core/styles";
import axios from 'axios';

import Button from "@material-ui/core/Button";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import api from '../common/api';
import ConfirmDialog from '../common/ConfirmDialog'

const defaultToolbarSelectStyles = {
  iconButton: {
  },
  iconContainer: {
    marginRight: "24px",
  },
};

class CustomToolbarSelect extends React.Component {
  constructor(props) {
    super(props);
      this.state = {
        dialog: {open: false, message: '', title:'', errors:{errors:{'work_order.tasks':[]}}},
    };
  }

  handleClickInverseSelection = () => {
      const indexes = this.props.selectedRows.data;
      var dialog = this.state.dialog
      var formData = new FormData();
      var i = 0;
      formData.set("maintenance_plan[id]", this.props.maintenance_plan_id);
      if (this.props.modelsAssignment){
        for (const [index, value] of indexes.entries()) {
          formData.set("versions["+i+"][id]", this.props.models[value.dataIndex].id);
          i++;
        } 
      } else if (this.props.vehiclesAssignment){
        for (const [index, value] of indexes.entries()) {
          formData.set("plates["+i+"][plate]", this.props.vehicles[value.dataIndex].plate);
          i++;
        } 

      }
      let self = this
      let errors = {}
      const token = localStorage.getItem('userToken')
      axios.post(api.maintenance_plans().assignVariations(),
        formData,
        {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
         )
        .then((response)=> {
          dialog.title = 'Asignación de modelos'
          dialog.success = 1
          dialog.open = 1
          dialog.message = 'Se ha asignado con éxito!'

          self.setState({dialog: dialog})
        })
        .catch(error => {
          dialog.title = 'Asignación de modelos'
          dialog.message = 'Ha ocurrido un error!'
          dialog.success = 0
          dialog.open = 1
//          dialog.errors = error.response.data
          var promise = new Promise(function(resolve, reject) {
            resolve(error.response.data);
            dialog.errors = error.response.data         
          });
          self.setState({dialog: dialog})
      })
  };

  handleClickDelete = () => {
      const indexes = this.props.selectedRows.data;
      var dialog = this.state.dialog
      var versions = []
      for (const [index, value] of indexes.entries()) {
        versions.push({id: this.props.models[value.dataIndex].id})
      } 
      let self = this
      let errors = {}
      const token = localStorage.getItem('userToken')
      axios.delete(api.maintenance_plans().unAssignVariations(this.props.maintenance_plan_id),{data:{versions: versions}, headers: {"Authorization" : `Bearer ${token}`}},
       
        )
        .then((response)=> {
          dialog.title = 'Asignación de modelos'
          dialog.success = 1
          dialog.open = 1
          dialog.message = 'Se ha desasignado con éxito!'

          self.setState({dialog: dialog})
        })
        .catch(error => {
          dialog.title = 'Asignación de modelos'
          dialog.message = 'Ha ocurrido un error!'
          dialog.success = 0
          dialog.open = 1
//          dialog.errors = error.response.data
          var promise = new Promise(function(resolve, reject) {
            resolve(error.response.data);
            dialog.errors = error.response.data         
          });
          self.setState({dialog: dialog})
      })
  };



  handleClickDeselectAll = () => {
    this.props.setSelectedRows([]);
  };

  handleRedirect(){
    window.location.href="/contracts"
  }

  handleDialogClose = () => {
    var dialog = this.state.dialog
    dialog.open = false
    dialog.errors = []
    this.setState({dialog: Dialog})
  }

  handleDialogAccept = () =>{
    window.location.href='/maintenance-plans' 
  }

  handleDialogCancel = () =>{
    this.handleDialogClose()
  }


  handleCancelButton = () => {
    window.location.href=`/maintenance-plans`
  }


  render() {
    const { classes } = this.props;

    return (
           <div className={classes.iconContainer}>
              <ConfirmDialog 
                      confirm_dialog={this.state.dialog.open} 
                      title={this.state.dialog.title}
                      message={this.state.dialog.message}
                      onClose={this.handleCancelButton} 
                      onAccept={this.handleDialogAccept}
                      onCancel={this.handleCancelButton}
                      errors={this.state.dialog.errors}
                />
              <Tooltip title={"Limpiar"}>
                <IconButton className={classes.iconButton} onClick={this.handleClickDeselectAll}>
                  <Cancel className={classes.icon} />
                </IconButton>
              </Tooltip>
              <Tooltip title={"Quitar"}>
                <IconButton className={classes.iconButton} onClick={this.handleClickDelete}>
                  <Delete className={classes.icon} />
                </IconButton>
              </Tooltip>
              <Tooltip title={"Asignar Modelos"}>
                <IconButton className={classes.iconButton} onClick={this.handleClickInverseSelection}>
                  <Publish className={[classes.icon, classes.inverseIcon].join(" ")} />
                </IconButton>
              </Tooltip>
            </div>
    );
  }
}

export default withStyles(defaultToolbarSelectStyles, { name: "CustomToolbarSelect" })(CustomToolbarSelect);